import { render } from "./EditAddress.vue?vue&type=template&id=6844a575&scoped=true"
import script from "./EditAddress.vue?vue&type=script&lang=js"
export * from "./EditAddress.vue?vue&type=script&lang=js"

import "./EditAddress.vue?vue&type=style&index=0&id=6844a575&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6844a575"]])

export default __exports__